// Method for getting categories for Blogs, Homeowner Resources and Homeowner Stories
export const filterCategoriesByName = (slug, categories) => {
  let postCategory = [];
  categories.forEach((category) => {
    if (category.node.slug === slug) {
      postCategory = category.node.wpChildren.nodes;
    }
  });

  let categoryProps = [];
  if (slug === 'financial-goals') {
    postCategory.forEach((data) => {
      categoryProps.push({ label: data.name, value: data.slug });
    });
  } else {
    categoryProps = [{ link: `/${slug}/`, label: 'All', slug: slug }];
    postCategory.forEach((data) => {
      categoryProps.push({ link: `/${slug}/${data.slug}/`, label: data.name, slug: data.slug });
    });
  }

  return categoryProps;
};

export const getFirstSubcategory = (categories) => {
  if (categories) {
    return categories.nodes[1];
  }
};

export const categoryIs = (slug, categories) => {
  return categories.some((category) => category.slug === slug);
};

export const filterPostsByCategory = (slug, posts) => {
  let filteredPosts = [];
  posts.forEach((post) => {
    if (categoryIs(slug, post.categories.nodes)) {
      filteredPosts.push(post);
    }
  });

  return filteredPosts;
};

export const getGeneratedRelatedPosts = (categorySlug, data) => {
  const getCategoryFragment = (slug) => {
    switch (slug) {
      case 'financial-goals':
        return 'autoRelatedFinancialGoalsBlogs';
      case 'home-financing-101':
        return 'autoRelatedHomeFinancingBlogs';
      case 'homeowner-tips':
        return 'autoRelatedHomeownerTipsBlogs';
      case 'hometap-happenings':
        return 'autoRelatedHometapHappeningsBlogs';
      case 'market-insights':
        return 'autoRelatedMarketInsightsBlogs';
      default:
        break;
    }
  };

  const generatedRelatedPosts = data[`${getCategoryFragment(categorySlug)}`].nodes.filter((blog) => {
    return blog.slug !== data.page.slug;
  });

  return generatedRelatedPosts;
};
